/**
 * The type of (redux) action to update the OneDrive access token.
 */
export const UPDATE_ONEDRIVE_TOKEN = 'UPDATE_ONEDRIVE_TOKEN';

/**
 * The type of (redux) action to set OneDrive sign-in pending state.
 */
export const SET_ONEDRIVE_AUTHORIZING = 'SET_ONEDRIVE_AUTHORIZING';
